import React, { memo, useEffect } from "react";

import TrainerDesctopBlock from "./TrainerDesctopBlock/TrainerDesctopBlock";
import TrainerMobileBlock from "./TrainerMobileBlock/TrainerMobileBlock";
import { NavbarFooterContext } from "../../containers/NavbarFooterContext";
import { useContext } from "react";

import { useTranslation } from "next-i18next";
import { useMediaQuery } from "../../../../../hooks/useMediaQuery";
import { useRouter } from "next/router";

function TrainerBlock({ allInstructors, hallsetId }) {
  const [t] = useTranslation();
  const { scheduleDefaultView } = useContext(NavbarFooterContext);

  const isDesktop = useMediaQuery("(min-width:768px)");
  const router = useRouter();

  const {
    query: { instructorsHash },
    asPath,
  } = router;

  useEffect(() => {
    if (!instructorsHash) return;

    router.replace(
      { pathname: `${asPath.split("#")[0]}`, hash: "_instructors", query: {} },
      undefined,
      {
        shallow: true,
      }
    );
  }, [instructorsHash]);

  return (
    <div className="club-trainers-block">
      {isDesktop ? (
        <TrainerDesctopBlock
          allInstructors={allInstructors}
          scheduleButton={t("schedule")}
          hallsetId={hallsetId}
          scheduleDefaultView={scheduleDefaultView}
        />
      ) : (
        <TrainerMobileBlock
          allInstructors={allInstructors}
          scheduleButton={t("schedule")}
          hallsetId={hallsetId}
          scheduleDefaultView={scheduleDefaultView}
          isClubMain
        />
      )}
      <div className="club-trainers-plug" id="_instructors"></div>
      <style jsx global>{`
        @import "./TrainerDesctopBlock/TrainerDesctopBlock.scss?8";
      `}</style>
    </div>
  );
}

export default memo(TrainerBlock);
